import React from 'react';
import { useHasAnyUserRequestPermission } from './hooks';
import { CustomErrorPage } from '../CustomErrorPage';

export const UserRequestsPermissionGuard: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { hasPermission, isLoading } = useHasAnyUserRequestPermission();

  if (isLoading) return null;
  if (!hasPermission) {
    return <CustomErrorPage status="404" statusMessage="Page not found" />;
  }

  return <>{children}</>;
};
